import { Enrolment } from '@/models/enrolment';
import { EnrolmentStatus } from '@/models/enrolment-status';
import EnrolmentService from '@/services/enrolments-service';

import { EnrolmentConfirmationUnsureTriggerPayloadConfiguration } from '../trigger-payload/enrolment-confirmation-unsure-trigger-payload-configuration';
import { TriggerPayload } from '../trigger-payload/trigger-payload';
import { TransitionTrigger } from './transition-trigger';

export class EnrolmentConfirmationUnsureTrigger extends TransitionTrigger {
	public constructor(excludedEnrolmentStatuses: EnrolmentStatus[]) {
		super('Other, please specify', excludedEnrolmentStatuses, new EnrolmentConfirmationUnsureTriggerPayloadConfiguration());
	}

	public equals(that: TransitionTrigger): boolean {
		return that instanceof EnrolmentConfirmationUnsureTrigger;
	}

	protected async performTransitions(enrolments: Readonly<Enrolment[]>, payload: TriggerPayload): Promise<void> {
		await EnrolmentService.triggerEnrolmentConfirmationUnsure(enrolments, payload.note || '');
	}
}
